import {
  createStyles,
  Icon,
  Theme,
  Typography,
  withStyles,
  WithStyles,
} from '@material-ui/core';
import * as classNames from 'classnames';
import * as React from 'react';
import { NavLink } from 'react-router-dom';

const styles = (theme: Theme) =>
  createStyles({
    navItem: {
      '&.disabled': {
        color: theme.palette.grey[400],
        cursor: 'default',
      },
      '&.main': {
        fontSize: '24px',
        margin: '0 30px',
        minHeight: '54px',
      },
      '&.sub': {
        fontSize: '14px',
        margin: '0 20px',
        minHeight: '40px',
      },
      alignItems: 'center',
      boxSizing: 'border-box',
      color: theme.palette.grey[800],
      display: 'flex',
      fontWeight: 400,
      margin: `20px 0`,
      padding: `0 10px`,
      textDecoration: 'none',
    },
    navText: {
      marginLeft: `12px`,
    },
    selectedStyle: {
      color: `#FFFFFF`,
    },
  });

interface IDefaultProps {
  iconClass: string;
  onClick: () => void;
}

type allProps = IProps & Partial<IDefaultProps>;

interface IProps extends WithStyles<typeof styles> {
  anchor: string;
  href: string;
}

class NavigationDrawerLink extends React.Component<allProps> {
  public static defaultProps: IDefaultProps = {
    iconClass: '',
    onClick: () => {/* no-op */}
  };

  public render() {
    const { anchor, iconClass, href, classes, onClick } = this.props;

    return (
      <NavLink
        to={href}
        className={classes.navItem}
        activeClassName={classes.selectedStyle}
        onClick={onClick}
      >
        {iconClass ? (
          <Icon
            className={classNames({
              [iconClass]: true,
            })}
          />
        ) : null}
        <Typography variant="headline" color="inherit" className={classes.navText}>
          {anchor}
        </Typography>
      </NavLink>
    );
  }
}

export default withStyles(styles)(NavigationDrawerLink);



// WEBPACK FOOTER //
// ./src/components/NavigationDrawerLink.tsx